import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-investor-terms',
  templateUrl: './investor-terms.component.html',
  styleUrls: ['./investor-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestorTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
